import {
  GET_SPORTSBOOK_TABS_REQUEST,
  GET_SPORTSBOOK_TABS_SUCCESS,
  GET_SPORTSBOOK_TABS_FAILURE,
  SPORTSBOOK_TABS_EVENTS_COUNT_WS_UPDATE
} from 'Store/constants';

import { PRE, LIVE, ALL_EVENTS } from 'Store/constants/sportTypes';

const initialState = {
  bulletinTabs: [],
  isLoading: true,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SPORTSBOOK_TABS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_SPORTSBOOK_TABS_SUCCESS:
      return { ...state, bulletinTabs: action.payload.tabs, isLoading: false, error: null };
    case GET_SPORTSBOOK_TABS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SPORTSBOOK_TABS_EVENTS_COUNT_WS_UPDATE:
      return {
        ...state,
        bulletinTabs: state.bulletinTabs.map(bulletinTab => {
          if (action.payload.isLive && bulletinTab.type === LIVE || !action.payload.isLive && bulletinTab.type === PRE) {
            return {
              ...bulletinTab,
              count: bulletinTab.count + action.payload.countChange,
              availableTabs: bulletinTab.availableTabs.map(availableTab => {
                if (availableTab.type === action.payload.sportType || availableTab.type === ALL_EVENTS) {
                  return {
                    ...availableTab,
                    count: availableTab.count + action.payload.countChange
                  };
                } else {
                  return availableTab;
                }
              })
            };
          } else {
            return bulletinTab;
          }
        })
      };
    
    default:
      return state;
  }
};
